import * as React from 'react';
import {FileObject, getFileByID} from 'api/library';
import validateResponse from 'helpers/validate-response';
import isError from 'helpers/isError';
import {IconLoading} from 'icons';

export interface FileContainerProps {
  id: FileObject['id'];
  children(file: FileObject): JSX.Element;
}

/**
 * This is a container for a file.
 * @param {FileContainerProps} props
 * @return {React.ReactElement<FileContainerProps>}
 * @constructor
 */
export default function FileContainer(
    props: FileContainerProps,
): React.ReactElement<FileContainerProps> {
  const [
    isLoaded,
    setLoaded,
  ] = React.useState<boolean>(false);

  const [
    file,
    setFile,
  ] = React.useState<FileObject | undefined>(undefined);

  React.useEffect(() => {
    setLoaded(false);
    getFileByID(props.id).then((response) => {
      validateResponse(response);
      if (response && !isError(response)) {
        setLoaded(true);
        setFile(response);
      }
    });
  }, []);

  /**
   * Render not found.
   * @return {JSX.Element}
   */
  function renderNotFound(): JSX.Element {
    return (
      <span>Изображение удалено с сервера</span>
    );
  }

  return isLoaded ? (
    file ? props.children(file) : renderNotFound()
  ) : <IconLoading />;
}
